export default function tableOfContentHeaders() {
  function insertAfter(newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling)
  }

  if (typeof window !== "undefined" && window.document) {
    const vWidth =
      window.innerWidth || window.document.documentElement.clientWidth // viewport
    const readTime = window.document.querySelector(".Readtime")
    const heroImg = window.document.querySelector(".Content-image")
    const heroImgImg = heroImg?.querySelector(".gatsby-image-wrapper")
    const blogInfo = window.document.querySelector(".Content-byline")
    const contentDate = blogInfo?.querySelector(".Content-date")

    if (vWidth < 841) {
      if (!!readTime && !!heroImgImg) {
        insertAfter(readTime, heroImgImg)
      }
    } else {
      if (!!readTime && !!contentDate) {
        insertAfter(readTime, contentDate)
      }
    }
  }
}
